import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.'

@vsingleton()
export class AdminPreferencesRoutes extends RouteBase {
  prefix = ROUTE_PREFIX + 'preferences.'

  index() {
    return this.ziggyRoute('index')
  }

  update() {
    return this.ziggyRoute('update')
  }

  customSorUpdate() {
    return this.ziggyRoute('custom_sort.update')
  }
}


